var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_22212",
    "data-name": "\\uADF8\\uB8F9 22212",
    transform: "translate(-1553 -1205)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_28426",
    "data-name": "\\uC0AC\\uAC01\\uD615 28426",
    width: 24,
    height: 24,
    transform: "translate(1553 1205)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "facebook-filled",
    d: "M23.8,8.379H21.536V5.344h1.845a.578.578,0,0,0,.6-.6V1.6a.578.578,0,0,0-.6-.6H21.209a3.867,3.867,0,0,0-3.987,4.136V8.319H14.6a.8.8,0,0,0-.8.8v2.142a.8.8,0,0,0,.8.8h2.559v6.576a.8.8,0,0,0,.8.8h2.8a.633.633,0,0,0,.446-.208.776.776,0,0,0,.208-.506h0V12.1h1.964a.716.716,0,0,0,.744-.6v-.06l.417-2.053a.89.89,0,0,0-.179-.684A.767.767,0,0,0,23.8,8.379Z",
    transform: "translate(1544.824 1206.775)",
    fill: "#212529"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon);
export default __webpack_public_path__ + "static/media/FooterIcon.c25d38ac75129be21b234ac3ca8981e0.svg";
export { ForwardRef as ReactComponent };